import type { ReactNode } from "react";
import { LogOut } from "lucide-react";
import { Button } from "@design-lab/shared/ui/design-system/Button";

type PinningActionBarProps = {
  onCancel: () => void;
  isCancelDisabled: boolean;
  variant?: "absolute" | "static";
  leftContent?: ReactNode;
};

export function PinningActionBar({
  onCancel,
  isCancelDisabled,
  variant = "absolute",
  leftContent
}: PinningActionBarProps) {
  const hasLeftContent = leftContent != null;
  const className =
    variant === "absolute"
      ? `absolute bottom-0 left-0 right-0 z-10 flex items-center ${hasLeftContent ? "justify-between" : "justify-end"} rounded-b-xl bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]`
      : `flex shrink-0 items-center ${hasLeftContent ? "justify-between" : "justify-end"} bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]`;

  return (
    <div className={className} data-testid="pinning-artboard-actions">
      {leftContent && <div className="flex items-center">{leftContent}</div>}
      <div className="flex items-center">
        <Button
          variant="link"
          className="flex items-center gap-1.5 text-blue-700 no-underline hover:text-blue-800 hover:no-underline"
          onPress={onCancel}
          data-testid="pinning-cancel"
          isDisabled={isCancelDisabled}
        >
          <LogOut className="h-4 w-4" />
          Exit
        </Button>
      </div>
    </div>
  );
}
